import Breadcrumbs from "@/components/Breadcrumbs";

export default function PageHeader({ title, subtitle, action, eyebrow, breadcrumbs }) {
  return (
    <div className="border-b border-[#E5E5E5] bg-white">
      {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumbs items={breadcrumbs} />}
      <div className="px-4 md:px-10 py-6 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          {eyebrow && <div className="bc-label mb-2">{eyebrow}</div>}
          <h1 className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-[#0D0D0D]" data-testid="page-title">{title}</h1>
          {subtitle && <p className="text-sm text-[#666666] mt-1 max-w-2xl">{subtitle}</p>}
        </div>
        {action && <div>{action}</div>}
      </div>
    </div>
  );
}
